import { useAuth } from '@affiliate-cabinet/auth'
import { getV3AffstoreTransferStatus, patchV3AffstoreTransferStatus, useMutation, useQuery } from '@affiliate-cabinet/rest'
import { BillingTypesComponents, BillingTypesPaths, ResponseErrorInterface } from '@affiliate-cabinet/types'

import { getBrandConfig } from '../../../config/brands'
import { affstoreTransferStatusEntity } from '../../constants/affstoreTransferStatus.entity'

const { brandConfig } = getBrandConfig()

export const useAffstoreTransferStatus = () => {
  const {
    auth: { isAuthorizedData },
  } = useAuth()

  const {
    data: affstoreTransferData,
    isFetching: affstoreTransferIsFetching,
    isRefetching: affstoreTransferIsRefetching,
    refetch: affstoreTransferRefetch,
  } = useQuery<unknown, ResponseErrorInterface, BillingTypesComponents['schemas']['AffstoreTransferStatus']>(
    ['getV3AffstoreTransferStatus'],
    () => getV3AffstoreTransferStatus(),
    {
      enabled: isAuthorizedData === true && brandConfig.brandName === 'affstore',
      keepPreviousData: true,
      refetchInterval: (data) => {
        if (data?.transferStatus !== 'in_progress') {
          return false
        }

        return 3000
      },
      refetchIntervalInBackground: true,
      retry: false,
      staleTime: 3000,
    },
  )

  const setAffstoreTransferStatusMutation = useMutation<
    BillingTypesPaths['/v3/affstore-transfer']['patch']['responses']['204'],
    ResponseErrorInterface,
    BillingTypesPaths['/v3/affstore-transfer']['patch']['requestBody']['content']['application/json']
  >(patchV3AffstoreTransferStatus, {
    retry: false,
  })

  return {
    affstoreTransferData: {
      finishedAt: affstoreTransferData?.finishedAt || null,
      legalNoticeConfirmed: affstoreTransferData?.legalNoticeConfirmed || null,
      transferStatus: affstoreTransferData?.transferStatus || affstoreTransferStatusEntity.AFFSTORE_TRANSFER_STATUS.notStarted,
    },
    affstoreTransferIsFetching,
    affstoreTransferIsRefetching,
    affstoreTransferRefetch,
    setAffstoreTransferStatus: setAffstoreTransferStatusMutation.mutate,
    setAffstoreTransferStatusIsLoading: setAffstoreTransferStatusMutation.isLoading,
  }
}
